module.exports = __webpack_public_path__ + "img/kfnImg.e577e02b.png";